import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './theme.css';

// `getElementById` devuelve `HTMLElement | null` y hasta ahora nadie miraba el null:
// si algun dia falta el div, `createRoot(null)` revienta con un mensaje del interior
// de React que no dice nada del index.html. La comprobacion cuesta dos lineas y
// convierte ese fallo en una frase que se entiende.
const contenedor = document.getElementById('root');
if (!contenedor) throw new Error('Falta <div id="root"> en index.html: la aplicación no tiene dónde montarse.');

createRoot(contenedor).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
